module.exports = __webpack_public_path__ + "img/20200118115724360截图20200118103649921.bdda4562.jpg";